import { v4 as uuid } from 'uuid';
import { isListNotEmpty, isNumberGreaterThanZero, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";

class OrderLineItem {
    id = uuid();
    name = null;
    sku = null;
    productId = null;
    variantId = null;
    quantity = 0;
    price = 0.0; // price per unit
    subtotal = 0.0; // quantity * price
    tax = 0.0;
    total = 0.0;
    metaData = [];
    // refundedQuantity = null;
    // refundedTax = null;
    // refundedSubtotal = null;
    // refundedTotal = null;

    constructor(orderLineItem) {
        if (isObjectNotEmpty(orderLineItem)) {
            if (isStringNotEmpty(orderLineItem.id)) { this.id = orderLineItem.id; }
            if (isStringNotEmpty(orderLineItem.name)) { this.name = orderLineItem.name; }
            if (isStringNotEmpty(orderLineItem.sku)) { this.sku = orderLineItem.sku; }
            if (isStringNotEmpty(orderLineItem.productId)) { this.productId = orderLineItem.productId; }
            if (isStringNotEmpty(orderLineItem.variantId)) { this.variantId = orderLineItem.variantId; }
            if (isNumberGreaterThanZero(orderLineItem.quantity)) { this.quantity = orderLineItem.quantity; }
            if (isNumberGreaterThanZero(orderLineItem.price)) { this.price = orderLineItem.price; }
            if (isNumberGreaterThanZero(orderLineItem.subtotal)) { this.subtotal = orderLineItem.subtotal; }
            if (isNumberGreaterThanZero(orderLineItem.tax)) { this.tax = orderLineItem.tax; }
            if (isNumberGreaterThanZero(orderLineItem.total)) { this.total = orderLineItem.total; }
            if (isListNotEmpty(orderLineItem.metaData)) { this.metaData = orderLineItem.metaData; }
            // if (isNumberGreaterThanZero(lineItem.refundedQuantity)) { this.refundedQuantity = lineItem.refundedQuantity; }
            // if (isNumberGreaterThanZero(lineItem.refundedTax)) { this.refundedTax = lineItem.refundedTax; }
            // if (isNumberGreaterThanZero(lineItem.refundedSubtotal)) { this.refundedSubtotal = lineItem.refundedSubtotal; }
            // if (isNumberGreaterThanZero(lineItem.refundedTotal)) { this.refundedTotal = lineItem.refundedTotal; }
        }
    }

    toDto = () => {
        return {
            id: this.id,
            name: this.name,
            sku: this.sku,
            productId: this.productId,
            variantId: this.variantId,
            quantity: this.quantity,
            price: this.price,
            subtotal: this.subtotal,
            tax: this.tax,
            total: this.total,
            metaData: this.metaData,
            // refundedQuantity: this.refundedQuantity,
            // refundedTax: this.refundedTax,
            // refundedSubtotal: this.refundedSubtotal,
            // refundedTotal: this.refundedTotal,
        };
    }
};

export default OrderLineItem;